import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useAppDispatch } from '../../../app/hooks';
import { initializeVendor } from '../state';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { VendorCreateHeader, VendorCreateForm } from '../components/VendorForm';

const VendorCreate: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(initializeVendor());
  }, [dispatch]);

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          <VendorCreateHeader />
          <VendorCreateForm />
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default VendorCreate;
